import React, { Component } from 'react'
import Radio from '../Radio/Radio'
import StyledRadioGroup from './StyledRadioGroup'

class RadioGroup extends Component {
  state = { checked: null };

  onChange = ({ target }) => {
    if (target.value !== this.state.value) {
      this.setState({ value: target.value })
      this.props.onChange && this.props.onChange({ target })
    }
  };

  render() {
    const { className, defaultChecked, layout, items, ...rest } = this.props
    const value = this.state.value || defaultChecked

    return (
      <StyledRadioGroup layout={layout} className={className}>
        {items.map(e => (
          <Radio key={e.id} value={e.id} text={e.name} checked={value == e.id} onChange={this.onChange} {...rest} />
        ))}
      </StyledRadioGroup>
    )
  }
}

RadioGroup.defaultProps = {
  layout: 'vertical',
}

export default RadioGroup
